var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// ---------------------------------------------------------------------------
// Size matching
//
// Used to follow the size chosen on the main product. Sizes are compared on a
// scale rather than by string, so "M" can find "L" when M is sold out. Scales
// never cross: a letter size will not match a shoe number, and an unrecognised
// label simply means no match, leaving that item's own selection alone.
// ---------------------------------------------------------------------------
const CTL_LETTER_SIZES = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'];

const CTL_LETTER_SYNONYMS = {
  '2XS': 'XXS',
  '3XS': 'XXXS',
  '2XL': 'XXL',
  '3XL': 'XXXL',
  '4XL': 'XXXXL',
};

function ctlNormaliseSize(label) {
  return String(label || '')
    .toUpperCase()
    .replace(/\s+/g, ' ')
    .trim();
}

// Takes the leading token, so "XS (30L)" reads as XS and "W28 / L30" as W28.
function ctlSizeToken(label) {
  const first = ctlNormaliseSize(label).split(/[\s/(),]+/)[0];
  return CTL_LETTER_SYNONYMS[first] || first;
}

function ctlSizeValue(label) {
  const token = ctlSizeToken(label);

  const letterIndex = CTL_LETTER_SIZES.indexOf(token);
  if (letterIndex !== -1) return { scale: 'letter', value: letterIndex };

  const waist = token.match(/^W(\d+(?:\.\d+)?)$/);
  if (waist) return { scale: 'waist', value: parseFloat(waist[1]) };

  const numeric = token.replace(',', '.');
  if (/^\d+(?:\.\d+)?$/.test(numeric)) return { scale: 'number', value: parseFloat(numeric) };

  return null;
}

class completeTheLook extends HTMLElement {
  constructor() {
    super();
    this.featured_image = '';
    this.handleVariantSwitch();
  }

  connectedCallback() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event && event.data && event.data.variant;
      if (variant) this.matchMainProductSize(variant.title);
    });
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
  }

  // Follow the size picked on the main product. The select only ever contains
  // in-stock variants, so the nearest option is by definition available.
  matchMainProductSize(mainLabel) {
    if (!this.item) this.item = this.querySelector('[ctl-product]');
    if (!this.item) return;

    const options = this.getVariantOptions();
    if (!options.length) return;

    const target = ctlNormaliseSize(mainLabel);

    let match = options.find((option) => ctlNormaliseSize(option.label) === target);

    if (!match) {
      const targetSize = ctlSizeValue(mainLabel);
      if (!targetSize) return;

      let best = null;
      options.forEach((option) => {
        const optionSize = ctlSizeValue(option.label);
        if (!optionSize || optionSize.scale !== targetSize.scale) return;

        const distance = Math.abs(optionSize.value - targetSize.value);
        // Ties go to the larger size: between two equally close options, sizing
        // up is the safer suggestion.
        const better = !best || distance < best.distance || (distance === best.distance && optionSize.value > best.value);
        if (better) best = { option, distance, value: optionSize.value };
      });

      // Nothing on a comparable scale — leave this item's own selection alone.
      if (!best) return;
      match = best.option;
    }

    // Hand off to the change handler either way, so the hidden variant id, the
    // price and the image update through one path.
    if (this.selectEl) {
      if (this.selectEl.value === match.value) return;
      this.selectEl.value = match.value;
      this.selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (match.element.checked) return;
    match.element.checked = true;
    match.element.dispatchEvent(new Event('change', { bubbles: true }));
  }

  handleVariantSwitch() {
    this.item = this.querySelector('[ctl-product]');
    if (!this.item) return;

    const variantJson = this.item.querySelector('[data-variant-json]');
    if (!variantJson) return;
    this.variantObject = JSON.parse(variantJson.innerHTML);

    // Two controls share this element: the recommendations use a dropdown, the
    // floating add-to-cart bar uses borderless radio pills. Either drives the
    // same update path.
    this.selectEl = this.item.querySelector('[data-product-select]');
    this.variantRadios = Array.from(this.item.querySelectorAll('[data-product-variant]'));
    if (!this.selectEl && !this.variantRadios.length) return;

    if (this.selectEl) {
      this.selectEl.addEventListener('change', () => this.applyVariant(this.selectEl.value));
    }

    this.variantRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) this.applyVariant(radio.value);
      });
    });
  }

  applyVariant(variantId) {
    const variant = this.variantObject.find((candidate) => candidate.id == variantId);
    if (!variant) return;

    const addButton = this.querySelector('[name="add"]');
    if (addButton && addButton.classList.contains('select_option_first')) {
      addButton.classList.remove('select_option_first');
    }

    this.updateVariantId(variant);
    this.updateItemPrice(variant);
    this.updateImage(variant);
  }

  // The options offered by whichever control this element is using, in a shape
  // the size matching below can work with regardless of which one it is.
  getVariantOptions() {
    if (this.selectEl) {
      return Array.from(this.selectEl.options).map((option) => ({
        value: option.value,
        label: option.textContent,
        element: option,
      }));
    }

    return this.variantRadios.map((radio) => ({
      value: radio.value,
      label: radio.dataset.label || radio.value,
      element: radio,
    }));
  }

  updateVariantId(variant) {
    // update input price
    const input = this.item.querySelector('[name="id"]');
    if (input) input.value = variant.id;
  }

  updateItemPrice(variant) {
    // update input price
    let itemUIComparePrice;

    // update UI price
    const itemUIPrice = Shopify.formatMoney(variant.price, window.theme.moneyFormat);
    const UIPriceEl = this.item.querySelector('[data-el-price]');
    if (UIPriceEl) UIPriceEl.innerHTML = itemUIPrice;

    // update UI compare price
    const UIComparePriceEl = this.item.querySelector('[data-el-compare-price]');
    if (UIComparePriceEl) {
      if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
        itemUIComparePrice = Shopify.formatMoney(variant.compare_at_price, window.theme.moneyFormat);
        UIComparePriceEl.innerHTML = `<del>${itemUIComparePrice}</del>`;
      } else UIComparePriceEl.innerHTML = null;
    }
  }

  updateImage(variant, item) {
    const featured_media = variant.featured_image;
    if (featured_media == null) return;

    if (featured_media.src == this.featured_image) return;

    this.featured_image = featured_media;

    const featuredImageEl = document.createElement('img');
    featuredImageEl.src = featured_media.src;
    featuredImageEl.alt = featured_media.alt ? featured_media.alt : '';

    const UIImageEl = this.item.querySelector('[data-el-media]');
    if (!UIImageEl) return;
    featuredImageEl.addEventListener('load', () => {
      UIImageEl.innerHTML = '';
      UIImageEl.appendChild(featuredImageEl);
    });
  }
}

customElements.define('completethe-look', completeTheLook);
